import { getPublicLists } from '@/lib/publicLists';
import { LANGUAGES as DEFAULT_LANGUAGES } from '@/lib/utils';

// The language list changes about never, so it's fetched once per page load and shared,
// instead of once per navigation.
let pending = null;

export function getLanguages() {
  if (!pending) {
    pending = getPublicLists('en')
      .then(({ languages }) => (languages && languages.length > 0 ? languages : DEFAULT_LANGUAGES));
  }
  return pending;
}

// Only languages the admin turned on may be translated into or linked as an alternate —
// otherwise a visitor's browser language alone could mint indexable URLs nobody supports.
export async function isLanguageEnabled(code) {
  if (!code) return false;
  if (code === 'en') return true;
  const langs = await getLanguages();
  return langs.some(l => l.code === code);
}